export const tabs = () => {
  const tabs_button = document.querySelectorAll('[data-tabs-target]');

  if (tabs_button.length > 0) {
    tabs_button.forEach(btn => {
      btn.addEventListener('click', event => {
        event.preventDefault();

        const targets =  document.querySelectorAll(btn.getAttribute('data-tabs-target'));

        if (targets.length > 0) {
          document.querySelectorAll('[data-tabs-target].active,.tab-panel.active')
            .forEach(active => active.classList.remove('active'));

          targets.forEach(target => target.classList.add('active'))
          btn.classList.add('active');

        }
      })
    })
  }
}
